import Toggle from 'ol-ext/control/Toggle';
import DragZoom from "ol/interaction/DragZoom";

export const homeButton = new Toggle(
    {
        html: '<i class="fas fa-home"></i>',
        className: "home",
        title: "Startkaartbeeld",
        active: false,
        onToggle: function (active) {
            console.log("Home is " + (active ? "activated" : "deactivated"));
        }
    });

const dragInteraction = new DragZoom({
    condition: function (e) {

        return true;
    }

})

dragInteraction.on("boxend", function () {
    dragInteraction.setActive(false)
})

export const zoomButton = new Toggle(
    {
        html: '<i class="fas fa-search-plus"></i>',
        className: "onetimezoombox",
        title: "ZoomBox",
        interaction: dragInteraction,
        active: false,
        onToggle: function (active) {
            console.log("ZoomBox is " + (active ? "activated" : "deactivated"));
        }
    });

export const legendButton = new Toggle(
    {
        html: '<i class="fas fa-list"></i>',
        className: "legend",
        title: "Legenda",
        active: false,
        onToggle: function (active) {
            console.log("Legend is " + (active ? "activated" : "deactivated"));
        }
    });

export const filterButton = new Toggle(
    {
        html: '<i class="fas fa-filter"></i>',
        className: "filter",
        title: "Filter",
        active: false,
        onToggle: function (active) {
            console.log("Filter is " + (active ? "activated" : "deactivated"));
        }
    });

//+++++ edit buttons

export const pandButton = new Toggle(
    {
        html: '<i class="far fa-building"></i>',
        className: "pand",
        title: "Pand",
        active: false,
        onToggle: function (active) {
            console.log("Pand is " + (active ? "activated" : "deactivated"));
        }
    });



export const perceelButton = new Toggle(
    {
        html: '<i class="fas fa-drafting-compass"></i>',
        className: "perceel",
        title: "Perceel",
        active: false,
        onToggle: function (active) {
            console.log("Perceel is " + (active ? "activated" : "deactivated"));
        }
    });

export const pointButton = new Toggle(
    {
        html: '<i class="fas fa-map-marker"></i>',
        className: "point",
        title: "Point",
        active: false,
        onToggle: function (active) {
            console.log("Point is " + (active ? "activated" : "deactivated"));
        }
    });

export const lineButton = new Toggle(
    {
        html: '<i class="fas fa-share-alt"></i>',
        className: "line",
        title: "Line",
        active: false,
        onToggle: function (active) {
            console.log("Line is " + (active ? "activated" : "deactivated"));
        }
    });


export const polygonButton = new Toggle(
    {
        html: '<i class="far fa-bookmark fa-rotate-270"></i>',
        className: "polygon",
        title: "Polygon",
        active: false,
        onToggle: function (active) {
            console.log("Polygon is " + (active ? "activated" : "deactivated"));
        }
    });








